export default __webpack_public_path__ + "static/media/5.76cb1179.mp3";